var _g, _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1668_234)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4923 28.3692L27.9963 8L15.4971 28.3709L27.9963 35.6274L40.4923 28.3692ZM40.5023 30.6981L27.9963 37.9512L15.4971 30.6997L27.9963 48L40.5023 30.6981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9951 8V22.7864L40.4927 28.3709L27.9951 8ZM27.9951 37.9529V48L40.5011 30.6981L27.9951 37.9529Z",
    fill: "#C0CBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9951 35.6275L40.4927 28.371L27.9951 22.7898V35.6275Z",
    fill: "#8197EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4971 28.371L27.9963 35.6275V22.7898L15.4971 28.371Z",
    fill: "#C0CBF6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 38,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#F88545"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5646 41.5575C43.4089 41.7132 43.1418 41.7605 42.9861 41.6048L42.3096 40.9284C42.1385 40.7573 41.8611 40.7573 41.69 40.9284L41.0136 41.6048C40.8579 41.7605 40.5907 41.7132 40.435 41.5575C39.9165 41.0389 39.0757 41.0389 38.5572 41.5575C38.0387 42.076 38.0387 42.9167 38.5572 43.4352C38.7129 43.5909 38.7603 43.8581 38.6046 44.0138L37.9281 44.6902C37.757 44.8613 37.757 45.1388 37.9281 45.3099L38.6046 45.9863C38.7603 46.142 39.0274 46.0946 39.1831 45.9389C39.7017 45.4204 40.5424 45.4204 41.0609 45.9389C41.5795 46.4575 41.5794 47.2982 41.0609 47.8167C40.9052 47.9724 40.8579 48.2396 41.0136 48.3953L41.69 49.0717C41.8611 49.2428 42.1385 49.2428 42.3096 49.0717L42.9861 48.3953C43.1418 48.2396 43.4089 48.2869 43.5646 48.4426C44.0832 48.9612 44.9239 48.9612 45.4424 48.4426C45.9609 47.9241 45.9609 47.0834 45.4424 46.5649C45.2867 46.4092 45.2393 46.142 45.395 45.9863L46.0715 45.3099C46.2426 45.1388 46.2426 44.8613 46.0715 44.6902L45.395 44.0138C45.2393 43.8581 45.2867 43.5909 45.4424 43.4352C45.9609 42.9167 45.9609 42.076 45.4424 41.5575C44.9239 41.0389 44.0832 41.0389 43.5646 41.5575Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1668_234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlEth);
export default __webpack_public_path__ + "static/media/PL-ETH.0736a7162796f7cef23eb64a2f31418d.svg";
export { ForwardRef as ReactComponent };